<template>
  <div class="text-center">
    <v-dialog
        v-model="dialog"
        width="500"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
            :color="color"
            dark
            v-bind="attrs"
            v-on="on"
            :width="width"
        >
          {{ title }}
        </v-btn>
      </template>

      <v-card>
        <v-card-title class="text-h5">
          Enter your pin code
        </v-card-title>

        <v-card-text>
          <v-form v-model="form" ref="form">
            <v-row>
              <v-text-field
                  full-width
                  v-model="pin_code"
                  label="PIN"
                  outlined
                  type="password"
                  autocomplete="new-password"
                  autofocus
                  :name="`username_${Math.random()}`"
                  @focus="onActivate"
                  @keydown.enter.prevent="actionWorkingEvent"
                  :rules="pinRules"
              ></v-text-field>
            </v-row>
            <v-row>
              <v-checkbox
                v-model="confirm"
                color="warning"
                :rules="confirm_rules"
              >
                <template v-slot:label>
                  <v-chip color="warning" outlined>
                    <span class="font-weight-bold">Do you want to finish the job? Are you sure?</span>
                  </v-chip>
                </template>
              </v-checkbox>
            </v-row>
          </v-form>

        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
              color="primary"
              text
              @click="actionWorkingEvent()"
              :disabled="!form"
          >
            OK
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import {mapFields} from "vuex-map-fields";

export default {
  name: 'TimeTrackerEnterEventConfirm',
  props: {
    color: {default: null},
    title: {default: null},
    event: {default: null},
    item: {default: null},
    width: {default: 120},
  },

  computed: {
    ...mapFields('CalendarDateUser', ['message_error', 'options', 'totalRecords', 'options.page', 'onlyFailedView', 'briefView', 'itemList',
      'loading', 'deleteLoading', 'updateLoading', 'restoring', 'selectedItemList', 'searchTermFile', 'searchTerm',
      'isAlive', 'action_loading', 'snack_color', 'snack_text', 'snack_flag']),
    loading_local() {
      return this.loading
    },
  },


  methods: {
    ...mapActions('CalendarDateUser', ['fetchActionItem', 'fetchItem']),
    onEditOpen(pin) {
    },
    onEditCancel(pin) {

    },

    secondsToISO(seconds) {
      if (seconds === null)
        return null
      let totalSeconds = seconds
      let hours = Math.floor(totalSeconds / 3600);
      totalSeconds %= 3600;
      let minutes = Math.floor(totalSeconds / 60);
      seconds = Math.floor(totalSeconds % 60);
      return String(hours).padStart(2, '0') + ':' + String(minutes).padStart(2, '0') + ':' + String(seconds).padStart(2, '0')
    },


    updateItem() {
      this.fetchItem(
          {
            itemId: this.item.id,
            dto_model: {to_consumer: 'HumanUserBaseDTO', from_consumer: 'HumanUserBaseDTO'}
          })
    },

    onActivate() {
      // console.log('focus')
      // this.updateItem()
      self = this
      setTimeout(function () {
        self.dialog = false
        self.pin_code = null
        self.confirm = false
        self.$refs.form.resetValidation()
      }, 30000);
    },

    actionWorkingEvent() {
      // item.last_status = event
      let params = {
        action_name: 'working_event',
        parameters: {
          event: this.event,
          user: this.item.human_user.id,
          pin_code: this.pin_code,
        },
        id_list: [this.item.id],
      }
      if (this.confirm === true) {
        // console.log('this.fetchActionItem(params)', params)
        this.fetchActionItem(params);
      }
      this.pin_code = null
      this.dialog = false
      this.$refs.form.resetValidation()
    },
  },

  mounted() {
  },

  data() {
    return {
      pin_code: null,
      dialog: false,
      form: false,
      pinRules: [
        v => !!v || 'PIN is required',
      ],
      confirm_rules: [
        v => !!v || 'Confirm is required',
      ],
      confirm: false,
    }
  },
}

</script>


<style scoped lang="scss">

</style>